import { render } from "./OrgStructure.vue?vue&type=template&id=5d0bd1a9&scoped=true"
import script from "./OrgStructure.vue?vue&type=script&lang=js"
export * from "./OrgStructure.vue?vue&type=script&lang=js"

import "./org-structure.scss?vue&type=style&index=0&id=5d0bd1a9&lang=scss&scoped=true"
import "./OrgStructure.vue?vue&type=style&index=1&id=5d0bd1a9&lang=scss"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0bd1a9"]])

export default __exports__